import type { PropsWithChildren } from 'react';

import { Typography } from 'src/app/components/Elements/Typography';

import { SectionContainer } from './styles';

interface BaseSectionProps
  extends PropsWithChildren<{
    sectionTitle: string;
  }> {}

export const SectionWithTitle = ({ sectionTitle, children }: BaseSectionProps) => {
  return (
    <SectionContainer>
      <Typography variant="overline" marginBottom={'s3'}>
        {sectionTitle}
      </Typography>
      {children}
    </SectionContainer>
  );
};
